// Redirect to SSO portal with current URL as redirect param
export const redirectToSSOPortal = () => {
  const loginUrl = new URL('/login', process.env.REACT_APP_SSO_PORTAL_URL);
  loginUrl.searchParams.set('redirect', window.location.href);
  window.location.href = loginUrl.href;
};
